'use strict'

require 'groupon-gig/src/cssVariablePolyfill.js'



// WEBPACK FOOTER //
// ./core/frontend/grpn-css-var-polyfill.coffee